import moment from 'moment';
import { TableRow, TableCell, Button } from '@mui/material';
import DeleteIcon from "../../../assets/icons/icon_trash.svg";

export default function CalculatedFieldsRow({ dataset, field, deleteCalcField, index, setLoading }) {

    const deleteButton = (params) => {
        return (
            <Button className='form_icon' onClick={() => deleteCalcField(params)}><img src={DeleteIcon} /></Button>
        )
    }

    return (
        <TableRow key={field?._id}>
            <TableCell>{index}</TableCell>
            <TableCell className="datasetname-cell">{field?.displayName || field?.name}</TableCell>
            <TableCell className="datasetname-cell">{field?.sql}</TableCell>
            <TableCell className="datasetname-cell">{field?.isDeleted === true ? 'True' : 'False'}</TableCell>
            <TableCell className="datasetname-cell">{field?.isHidden === true ? 'True' : 'False'}</TableCell>
            <TableCell> {moment(dataset?.updatedAt).fromNow()} </TableCell>
            <TableCell className="edit-cell action-cell">{deleteButton({ _id: field?._id, name: field?.displayName || field?.name })}
            </TableCell>

        </TableRow>
    )
}

